var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCartFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7499 25.925C15.1908 25.925 15.5482 25.5676 15.5482 25.1268C15.5482 24.6859 15.1908 24.3285 14.7499 24.3285C14.309 24.3285 13.9517 24.6859 13.9517 25.1268C13.9517 25.5676 14.309 25.925 14.7499 25.925Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5307 25.925C23.9715 25.925 24.3289 25.5676 24.3289 25.1268C24.3289 24.6859 23.9715 24.3285 23.5307 24.3285C23.0898 24.3285 22.7324 24.6859 22.7324 25.1268C22.7324 25.5676 23.0898 25.925 23.5307 25.925Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H11.5965L13.7198 19.9142C13.7977 20.2773 13.9997 20.6019 14.2911 20.8321C14.5825 21.0623 14.9451 21.1837 15.3163 21.1754H23.1232C23.4865 21.1749 23.8388 21.0504 24.1218 20.8225C24.4048 20.5946 24.6016 20.277 24.6797 19.9222L25.9969 13.9912H24.6797",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartFigma);
export default __webpack_public_path__ + "static/media/shopping-cart-figma.b3044bcf94a7cd7e337c923831da3b21.svg";
export { ForwardRef as ReactComponent };